module.exports = __webpack_public_path__ + "static/noData.b0e4e028.png";